import Router, { NavigationGuard } from 'vue-router';

/**
 * Sign in behavior.
 * @export
 * @enum {number}
 */
export enum SignInType {
    /**
     * Uses redirect.
     */
    Default,
    /**
     * Uses hidden iframe to silent signin.
     */
    Silent
}

/**
 * Contract for auth service.
 * @export
 * @interface AuthServiceContract
 */
export interface AuthServiceContract {
    readonly isAuthenticated: boolean;
    readonly accessToken: string | null;
    readonly userProfile: {};
    init(): void;
    startupAsync(callback: () => Promise<any>): Promise<any>;
    createNavigationGuard(): NavigationGuard;
    createSignInRouteComponent(router: Router, type: SignInType): Component;
    signIn(type: SignInType, args?: any): Promise<any>;
    signOut(type: SignInType, args?: any): Promise<any>;
}
